module.exports = __webpack_public_path__ + "static/img/bonusFocusImg.4aacb85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/bonusFocusImg.png
// module id = c672
// module chunks = 0